<template>
    <div>
        <form>
            <div class="row">
                <div class="col-12">
                    <h5 style="margin-bottom: 1rem; margin-top: 2rem;">I want the hours for this client to be approved:</h5>
                </div>
                <div class="col-8">
                    <hr />
                </div>
                <div class="col-4"></div>
                <div class="col-4">
                    <input type="radio" id="workfix" value="workfix" @change="updateOrganizationConfig()" v-model="organizationConfig.approved_by"/><label for="workfix">Workfix</label>
                </div>
                <div class="col-4">
                    <input type="radio" id="company" value="company" @change="updateOrganizationConfig()" v-model="organizationConfig.approved_by"/><label for="company">Company</label>
                </div>
                <div class="col-4"></div>
                <div class="col-8">
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <input type="radio" id="automatic" value="auto" @change="updateOrganizationConfig()" v-model="organizationConfig.approved_policy" /><label for="automatic">Automatic</label>
                </div>
                <div class="col-4">
                    <input type="radio" id="manual" value="manual" @change="updateOrganizationConfig()" v-model="organizationConfig.approved_policy" /><label for="manual">Manual</label>
                </div>
            </div>
            
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import 'vue-multi-select/dist/lib/vue-multi-select.css';
    import store from '../../store.js';

    export default {
        data() {
            return {
                comment: '',
                organizationConfig: {
                    "organization": {
                        "id": null,
                        "name": ""
                    },
                    "approved_by": "company",
                    "approved_policy": "manual"
                }
            };
        },
        async   created() {
            store.dispatch('organizations/getConfig', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, company_id: this.organization}).then((res) => {
                if (res.status === 200) {
                    this.organizationConfig = res.data.data
                }
            }).catch((err) => {
                console.log(err)
                alert('Unexpected error with organization config')
            });   

        },
        props: ['index', 'title', 'value', 'name', 'organization'],
        methods: {
            updateOrganizationConfig() {
                store.dispatch('organizations/updateConfig', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, company_id: this.organization, config: this.organizationConfig}).then((res) => {
                }).catch((err) => {
                    console.log(err)
                    alert('Unexpected error with organization config')
                }); 
            },
        },
        components: {
        },
        computed: {
            ...mapGetters('employments', [
                'getEmployment'
            ]),
            dateFormatted: {
                get () {
                    return moment(this.leaveRequest.created_at, "YYYY-MM-DD").format('DD/MM/YYYY') + ' (' + this.leaveRequest.hours + ' hours)'
                }, 
                set (value) {
                    this.leaveRequest.created_at = value
                }
            }
        },
        watch: {
        }
    }
</script>

<style lang="scss">
    @import "./assets/configuration.scss";
</style>
